// Import
import React from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import "dayjs/locale/it";
import { alpha, Box, useTheme } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import i18next from "i18next";
import "./style.css";

// Interface
interface DataPickerCstInterface {
  id: string;
  label?: string;
  value: any;
  placeholder?: string;
  onChange: (value: any) => void;
  customWidth?: string;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  required?: boolean;
  sx?: { [key: string]: string };
  minutesStep?: number;
  timeStepsMinutes?: number;
  minDate?: string;
}

// eslint-disable-next-line no-empty-pattern
const TimePickerCst: React.FC<DataPickerCstInterface> = (props) => {
  const {
    id,
    label,
    error,
    value,
    onChange,
    errorMessage,
    disabled,
    required,
    sx,
    minutesStep,
    timeStepsMinutes,
    minDate,
  } = props;

  const currentLanguage = i18next.language;
  const theme = useTheme();

  return (
    <Box
      id={id}
      sx={{
        minWidth: "200px",
        width: "100%",
        ...sx,
      }}
    >
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={currentLanguage}
      >
        <DemoContainer
          sx={{ width: "100%", pt: 0, overflow: "visible", display: "block" }}
          components={["TimePicker"]}
        >
          <DateTimePicker
            label={label}
            value={value ? dayjs(value) : null}
            minutesStep={minutesStep}
            onChange={(value: any) => {
              onChange(value);
            }}
            timeSteps={{ minutes: timeStepsMinutes || 5 }}
            slotProps={{
              textField: {
                size: "small",
                error: error,
                helperText: error ? errorMessage : "",
                required: required,
              },
              layout: {
                sx: {
                  ul: {
                    "&::-webkit-scrollbar": {
                      width: "6px",
                      background: alpha(theme.palette.text.primary, 0.1),
                    },
                    "::-webkit-scrollbar-thumb": {
                      borderRadius: 6,
                      background: alpha(theme.palette.text.primary, 0.2),
                    },
                    "::-webkit-scrollbar-thumb:hover": {
                      background: alpha(theme.palette.text.primary, 0.4),
                    },
                  },
                },
              },
            }}
            sx={{
              width: "100%",
            }}
            minDate={minDate && dayjs(minDate)}
            disabled={disabled}
          />
        </DemoContainer>
      </LocalizationProvider>
    </Box>
  );
};

export default TimePickerCst;
